import { createBrowserRouter, Navigate } from "react-router-dom";
import { ProtectedRoute } from "../../components/ProtectedRoute/ProtectedRoute";
import { LoginPage } from "../../components/Login/LoginPage";
import _404 from "../../_base/component/_layout/_404";
import { Layout } from "../../_base/component/_layout/_layout";
import { LayoutAuth } from "../../_base/component/_layout/_layoutAuth";
import { AuthenticationTitle } from "../../_base/component/_login/_login";
import { SubmitPassRecovery } from "../../_base/component/_passRecovery/_passrecovery";
import { SelectListItem } from "../../model/SelectListItem";
import Commune from "../../views/Address/Commune";
import District from "../../views/Address/District";
import Province from "../../views/Address/Province";
import CategoryFeatureView from "../../views/Category/CategoryFeatureView/categoryFeatureView";
import ProductList from "../../views/ProductManager/ProductList/MainView";
import TechnicalCommon from "../../views/ProductManager/TechnicalCommon/MainView";
import Brand from "../../views/Sell/Brand";
import WarranteeBrandCategory from "../../views/Warrantee/BrandCategory";
import OrderList from "../../views/Sell/OrderList/OrderList";
import PaymentMethod from "../../views/Sell/PaymentMethod";
import Home from "../../views/home/homeView";
// import Brand from "../../views/Brand"
import AddCoupon from "../../../src/views/Marketing/Coupons/CreateCoupons";
import EditCoupon from "../../../src/views/Marketing/Coupons/EditCoupons";
import { AuthenticationRegister } from "../../_base/component/_register/_register";
import ArticleCategory from "../../views/Article/ArticleCategory";
import ArticleList from "../../views/Article/ArticleList";
import HomeAttrView from "../../views/Attribute/homeView";
import BuildPcAccessory from "../../views/BuildPcAccessory";
import CategoryAttrManagerView from "../../views/Category/categoryAttrManager";
import HomeView from "../../views/Category";
import ComboSet from "../../views/ComboSet";
import CreateView from "../../views/ComboSet/CreateView";
import EditView from "../../views/ComboSet/EditView";
import ConfigWeb from "../../views/ConfigWeb/MainView";
import FixedContent from "../../views/Content/FixedContent";
import FixedContentType from "../../views/Content/FixedContentType";
import Media from "../../views/Content/Media";
import MediaGroup from "../../views/Content/MediaGroup";
import Customer from "../../views/CustomerManager/Customer";
import CustomerGroup from "../../views/CustomerManager/CustomerGroup";
import InstallmentOrder from "../../views/Installment/InstallmentOrder/MainView";
import InstallmentSetting from "../../views/Installment/InstallmentSetting/MainView";
import BannerLocation from "../../views/Marketing/BannerLocation";
import BannerManager from "../../views/Marketing/BannerManager";
import CouponsList from "../../views/Marketing/Coupons/MainIndex";
import ProductAdsCategory from "../../views/Marketing/ProductAdsCategory";
import ProductAdsList from "../../views/Marketing/ProductAdsList/ProductAdsList";
import ProductDealManager from "../../views/Marketing/ProductDealManager";
import ConfigGroup from "../../views/ProductManager/ConfigGroup";
import EditViewConfigGroup from "../../views/ProductManager/ConfigGroup/EditView/EditViewConfigGroup";
import Collection from "../../views/ProductManager/ProductCollection";
import CollectionProdList from "../../views/ProductManager/ProductCollection/CollectionProdList/CollectionProdList";
import CollectionForm from "../../views/RegistrationForm/CollectionForm";
import OrderStatus from "../../views/Sell/OrderStatusList";
import BehavioralStatistics from "../../views/Statistical/BehavioralStatistics";
import MostAddCartProduct from "../../views/Statistical/MostAddCartProduct";
import MostViewProduct from "../../views/Statistical/MostViewProduct";
import SearchKeyword from "../../views/Statistical/SearchKeyword";
import Tags from "../../views/System/Tags/MainView";
import UrlRedirect from "../../views/System/UrlRedirect/MainView";
import TradeIn from "../../views/TradeInManager/TradeIn";
import TradeInOrderNew from "../../views/TradeInManager/TradeInOrderNew";
import TradeInOrderOld from "../../views/TradeInManager/TradeInOrderOld";
import TradeInProductList from "../../views/TradeInManager/TradeInProduct/TradeInProductList";
import UserCommentList from "../../views/UserManager/UserCommentList";
import UserReviewList from "../../views/UserManager/UserReviewList";
import WarranteeSamsungList from "../../views/Warrantee/WarranteeSamsung";
import Voucher from "../../views/Voucher/Voucherlist/index";
import VoucherTest from "../../views/Voucher/VoucherTest/index";
import RedirectPage from "../../views/Redirect";
import ProductListV2 from "../../views/ProductManager/ProductList/MainView/index2";
import ArticleEmail from "../../views/RegistrationForm/ArticleEmail";
import WarranteeSamsungSessionList from "../../views/Warrantee/WarranteeSamsungSession";
import HomeViewCategoryV2 from "../../views/Category/index2";
import ProductAddOn from "../../views/ProductManager/ProductAddOn";
import CustommerInput from "../../views/CustommerClient/CustomerInput/CustommerInput";
import CustommerReviewList from "../../views/CustommerClient/CustommerReview/CustommerReview";
import CustomerComplaintList from "../../views/CustommerClient/CustomerComplaint/CustomerComplaintList";
import CategorySeo from "../../views/Category/SEO/categorySeo";
import UpdateExcelSEOSp from "../../views/Marketing/UpdateExcelSeoSp";
import MenuGroupListView from "../../views/Admin/MenuGroup/MenuGroupListView";
import CollectionRecruitment from "../../views/Collection/CollectionRecruitment/CollectionRecruitment";
import CollectionWarranty from "../../views/Collection/CollectionWarranty/CollectionWarranty";
import GroupAPIList from "../../views/Admin/APIGroup/GroupAPIList";
import DataSynchronization from "../../views/System/DataSynchronization";
import ClearCache from "../../views/System/ClearCache";
import UploadImageOnline from "../../views/UploadImage/UploadImage";
import MenuContent from "../../views/MenuContent";
import HomeBlockList from "../../views/HomeBlock/HomeBlockList";
import HomeBlockEdit from "../../views/HomeBlock/HomeBlockEdit";
import HomeBlockTemplates from "../../views/HomeBlock/HomeBlockTemplates";
import HomeBlockGuide from "../../views/HomeBlock/HomeBlockGuidePage";
import ArticleRecruitment from "../../views/Article/ArticleRecruitment";
import LogWeb from "../../views/Admin/LogWeb/LogWeb";
import WorkingTime from "../../views/WorkingTime/WorkingTime";
import Congvanlist from "../../views/DocumentMng/Congvan/CongVanList";
import CongvanCreate from "../../views/DocumentMng/Congvan/CongvanCreate";
import CongVanEdit from "../../views/DocumentMng/Congvan/CongVanEdit";
import DealShockingPrice from "../../views/Marketing/DealShockingPrice/DealShockingPrice";
import CollectionFrame from "../../views/ProductManager/ProductFrameCollection";
import CollectionFrameProdList from "../../views/ProductManager/ProductFrameCollection/CollectionProdList/CollectionProdList";
import HeThongTaiLieu from "../../views/DocumentMng/HeThongTaiLieu/HeThongTaiLieu";
import DetailView from "../../views/ProductManager/ProductFrameCollection/DetailView";
import OrderListAI from "../../views/Sell/OrderList/OrderListAI";
import ImageContentKH from "../../views/Content/ImageContentKH/ImageContentKH";
import CreateViewProduct from "../../views/ProductManager/ProductList/CreateView/CreateView";
import FAQ from "../../views/FAQ/FAQ";
import ArticleReward from "../../views/Article/ArticleReward";
import AppSettingMore from "../../views/AppSettingMore/AppSettingMore";
import CreateArticle from "../../views/Article/ArticleList/CreateView";
import EditArticle from "../../views/Article/ArticleList/EditView";
import ListCategoryFAQs from "../../views/FAQ/ListCategoryFAQs";
import ConfigGroupV2 from "../../views/ProductManager/ConfigGroupV2";
import EditViewConfigGroupV2 from "../../views/ProductManager/ConfigGroupV2/EditView/EditViewConfigGroupV2";
import CreateViewConfigGroupV2 from "../../views/ProductManager/ConfigGroupV2/CreateView/CreateViewConfigGroupV2";
import { TradeInOverviewV2 } from "../../views/TradeInManagerV2/TradeInOverview";
import { TradeInProductV2 } from "../../views/TradeInManagerV2/TradeInProduct";
import { TradeInCategoryV2 } from "../../views/TradeInManagerV2/TradeInCategory";
import { TradeInUpgradeProductV2 } from "../../views/TradeInManagerV2/TradeInUpgradeProduct/index";
import ListProductNoAttribute from "../../views/ProductManager/ListProductNoAttribute";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    errorElement: <_404 />,
    action: async ({ request }) => {
      // if (auth)
      //  return protectedLoader;
    },
    children: [
      {
        path: "/",
        element: <Home />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Trang chủ";
            model.Value = "/";
            return model;
          },
        },
      },
      {
        path: "/product-manager/category",
        children: [
          {
            index: true,
            element: (
              <>
                {/* <HomeView></HomeView> */}
                <HomeViewCategoryV2></HomeViewCategoryV2>
              </>
            ),
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  Disabled: true,
                  Group: null,
                  Selected: false,
                  Text: "",
                  Value: "",
                };
                model.Text = "Danh mục sản phẩm";
                model.Value = "/product-manager/category";
                return model;
              },
            },
          },
          {
            path: "/product-manager/category/category-feature/:cat_id",
            index: true,
            element: <CategoryFeatureView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  Disabled: false,
                  Group: null,
                  Selected: false,
                  Text: "",
                  Value: "",
                };
                model.Text = "Nội dung nổi bật của danh mục";
                model.Value =
                  "/product-manager/category/category-feature/:cat_id";
                return model;
              },
            },
          },
          {
            path: "/product-manager/category/category-attr/:cat_id",
            index: true,
            element: <CategoryAttrManagerView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  Disabled: false,
                  Group: null,
                  Selected: false,
                  Text: "",
                  Value: "",
                };
                model.Text = "Thuộc của danh mục";
                model.Value = "/product-manager/category/category-attr/:cat_id";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/product-manager/list-product-no-attribute",
        element: <ListProductNoAttribute />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm chưa có thuộc tính";
            model.Value = "/product-manager/list-product-no-attribute";
            return model;
          },
        },
      },
      {
        path: "/product-manager/product-list",
        // element: <ProductList />,
        element: <ProductListV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách sản phẩm";
            model.Value = "/product-manager/product-list";
            return model;
          },
        },
      },
      {
        path: "/product-manager/edit-product/:id",
        // element: <ProductList />,
        element: <CreateViewProduct />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa sản phẩm";
            model.Value = "/product-manager/edit-product";
            return model;
          },
        },
      },
      {
        path: "/product-addon",
        // element: <ProductList />,
        element: <ProductAddOn />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách SP mua kèm";
            model.Value = "/product";
            return model;
          },
        },
      },
      {
        path: "/product-manager/category-seo",
        element: <CategorySeo />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh mục SEO";
            model.Value = "/product-manager/category-seo";
            return model;
          },
        },
      },

      // {
      //   path: "/category-seo/create",
      //   element: <CreateViewSeo />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Danh mục SEO";
      //       model.Value = "/category-seo";
      //       return model;
      //     },
      //   },
      // },

      // {
      //   path: "/technical-common",
      //   element: <TechnicalCommon />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Danh mục thông số kỹ thuật";
      //       model.Value = "/technical-common";
      //       return model;
      //     },
      //   },
      // },
      {
        path: "/sales-manager/order-list",
        element: (
          <ProtectedRoute>
            <OrderList />
          </ProtectedRoute>
        ),
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách đơn hàng";
            model.Value = "/sales-manager/order-list";
            return model;
          },
        },
      },
      {
        path: "/sales-manager/order-ai",
        element: (
          <ProtectedRoute>
            <OrderListAI />
          </ProtectedRoute>
        ),
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách đơn hàng";
            model.Value = "/sales-manager/order-ai";
            return model;
          },
        },
      },
      {
        path: "/payment",
        element: <PaymentMethod />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách phương thức thanh toán";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/order-status",
        element: <OrderStatus />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách trạng thái đơn hàng";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/product-manager/brand",
        element: <Brand />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Thương hiệu";
            model.Value = "/product-manager/brand";
            return model;
          },
        },
      },
      {
        path: "/commune",
        element: <Commune />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Phường/Xã";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/province",
        element: <Province />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Tỉnh/Thành phố";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/district",
        element: <District />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Quận/Huyện";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/product-manager/attribute",
        element: <HomeAttrView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách thuộc tính";
            model.Value = "/product-manager/attribute";
            return model;
          },
        },
      },
      {
        path: "/article-manager/article-category",
        element: <ArticleCategory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh mục bài viết";
            model.Value = "/article-manager/article-category";
            return model;
          },
        },
      },
      {
        path: "/article-manager/article-list",
        element: <ArticleList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách bài viết";
            model.Value = "/article-manager/article-list";
            return model;
          },
        },
      },
      {
        path: "/article-manager/create-article",
        element: <CreateArticle />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Tạo mới bài biết";
            model.Value = "/article-manager/create-article";
            return model;
          },
        },
      },
      {
        path: "/article-manager/edit-article/:id",
        element: <EditArticle />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa bài biết";
            model.Value = "/article-manager/edit-article/:id";
            return model;
          },
        },
      },
      {
        path: "/article-manager/article-reward",
        element: <ArticleReward />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Bài viết khen thưởng";
            model.Value = "/article-manager/article-reward";
            return model;
          },
        },
      },
      // {
      //   path: "/redirect",
      //   element: <RedirectPage />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Tính năng Redirect";
      //       model.Value = "/redirect";
      //       return model;
      //     },
      //   },
      // },
      {
        path: "/combo/combo-set",
        element: <ComboSet />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách combo set";
            model.Value = "/combo/combo-set";
            return model;
          },
        },
      },
      {
        path: "/combo/combo-set-add",
        element: <CreateView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Tạo mới combo set";
            model.Value = "/combo/combo-set-add";
            return model;
          },
        },
      },
      {
        path: "/combo/combo-set-edit/:id",
        element: <EditView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa combo set";
            model.Value = "/combo/combo-set-edit";
            return model;
          },
        },
      },

      {
        path: "/fixed-content/fixed-content",
        element: <FixedContent />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách nội dung cố định";
            model.Value = "/fixed-content/fixed-content";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/image-content-KH",
        element: <ImageContentKH />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách ảnh khách hàng";
            model.Value = "/fixed-content/image-content-KH";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/fixed-menu",
        element: <MenuContent />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Quản lý nội dung menu";
            model.Value = "/fixed-content/fixed-menu";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/home-block",
        element: <HomeBlockList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Block trang chủ";
            model.Value = "/fixed-content/home-block";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/home-block/templates",
        element: <HomeBlockTemplates />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Mẫu block trang chủ";
            model.Value = "/fixed-content/home-block/templates";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/home-block/huong-dan/:topic?",
        element: <HomeBlockGuide />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Hướng dẫn sử dụng";
            model.Value = "/fixed-content/home-block/huong-dan";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/home-block/:id",
        element: <HomeBlockEdit />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sửa block trang chủ";
            model.Value = "/fixed-content/home-block";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/fixed-content-type",
        element: <FixedContentType />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách danh mục nội dung cố định";
            model.Value = "/fixed-content/fixed-content-type";
            return model;
          },
        },
      },
      // {
      //   path: "/Config/config-web",
      //   element: <ConfigWeb />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Config Web";
      //       model.Value = "/Config/config-web";
      //       return model;
      //     },
      //   },
      // },
      {
        path: "/Config/app-setting-more",
        element: <AppSettingMore />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Cấu hình hệ thống";
            model.Value = "/Config/app-setting-more";
            return model;
          },
        },
      },
      {
        path: "/Config/tag",
        element: <Tags />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách tag";
            model.Value = "/Config/tag";
            return model;
          },
        },
      },
      {
        path: "/Config/data-synchronization",
        element: <DataSynchronization />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Đồng bộ dữ liệu";
            model.Value = "/Config/data-synchronization";
            return model;
          },
        },
      },
      {
        path: "/Config/faq",
        element: <ListCategoryFAQs />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "FAQs";
            model.Value = "/Config/faq";
            return model;
          },
        },
      },
      {
        path: "/Config/faq/:id",
        element: <FAQ />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách FAQs";
            model.Value = "/Config/faq/:id";
            return model;
          },
        },
      },
      {
        path: "/Config/working-time",
        element: <WorkingTime />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Quản lý chi nhánh";
            model.Value = "/Config/working-time";
            return model;
          },
        },
      },
      {
        path: "/fixed-content/media",
        element: <Media />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách media";
            model.Value = "/fixed-content/media";
            return model;
          },
        },
      },
      {
        path: "/media-group",
        element: <MediaGroup />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách danh mục media";
            model.Value = "/media-group";
            return model;
          },
        },
      },
      {
        path: "/customer",
        element: <Customer />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách khách hàng";
            model.Value = "/customer";
            return model;
          },
        },
      },
      {
        path: "/customer-group",
        element: <CustomerGroup />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách nhóm khách hàng";
            model.Value = "/customer-group";
            return model;
          },
        },
      },

      {
        path: "/marketing-manager/product-ads-category",
        element: <ProductAdsCategory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Facebook Product Ads";
            model.Value = "/marketing-manager/product-ads-category";
            return model;
          },
        },
      },
      {
        path: "/marketing-manager/product-ads",
        element: <ProductAdsList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Product Ads";
            model.Value = "/marketing-manager/product-ads";
            return model;
          },
        },
      },
      {
        path: "/marketing-manager/banner",
        element: <BannerManager />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách Banner";
            model.Value = "/marketing-manager/banner";
            return model;
          },
        },
      },
      {
        path: "/marketing-manager/banner-location",
        element: <BannerLocation />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Quản lý vị trí Banner";
            model.Value = "/marketing-manager/banner-location";
            return model;
          },
        },
      },
      {
        path: "/coupon",
        element: <CouponsList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Coupon khuyến mại";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/coupons-set-edit",
        element: <EditCoupon />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/coupon-set-add",
        element: <AddCoupon />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách";
            model.Value = "/menu";
            return model;
          },
        },
      },
      {
        path: "/customer/user-comment",
        element: <UserCommentList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Trao đổi người dùng";
            model.Value = "/customer/user-comment";
            return model;
          },
        },
      },
      {
        path: "/customer/user-review",
        element: <UserReviewList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Đánh giá người dùng";
            model.Value = "/customer/user-review";
            return model;
          },
        },
      },
      // {
      //   path: "/marketing-manager/product-deal",
      //   element: <ProductDealManager />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Deal/Giờ vàng";
      //       model.Value = "/marketing-manager/product-deal";
      //       return model;
      //     },
      //   },
      // },
      // {
      //   path: "/marketing-manager/deal-shocking-price",
      //   element: <DealShockingPrice />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         Disabled: true,
      //         Group: null,
      //         Selected: false,
      //         Text: "",
      //         Value: "",
      //       };
      //       model.Text = "Deal giá sốc";
      //       model.Value = "/marketing-manager/deal-shocking-price";
      //       return model;
      //     },
      //   },
      // },
      {
        path: "/marketing-manager/product-seo-upload-excel",
        element: <UpdateExcelSEOSp />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Update Excel SEO sản phẩm";
            model.Value = "/marketing-manager/product-seo-upload-excel";
            return model;
          },
        },
      },
      {
        path: "/buld-pc/build-pc-accessory",
        element: <BuildPcAccessory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Link kiện xây dựng";
            model.Value = "/buld-pc/build-pc-accessory";
            return model;
          },
        },
      },
      {
        path: "/product-manager/config-group",
        element: <ConfigGroup />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Biến thể sản phẩm";
            model.Value = "/product-manager/config-group";
            return model;
          },
        },
      },
      {
        path: "/product-manager/config-group-v2",
        element: <ConfigGroupV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Biến thể sản phẩm v2";
            model.Value = "/product-manager/config-group-v2";
            return model;
          },
        },
      },
      {
        path: "/product-manager/config-group/edit",
        element: <EditViewConfigGroup />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa biến thể sản phẩm";
            model.Value = "/product-manager/config-group/edit";
            return model;
          },
        },
      },
      {
        path: "/product-manager/config-group-v2/edit",
        element: <EditViewConfigGroupV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa biến thể sản phẩm";
            model.Value = "/product-manager/config-group-v2/edit";
            return model;
          },
        },
      },
      {
        path: "/product-manager/config-group-v2/create",
        element: <CreateViewConfigGroupV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Thêm mới biến thể sản phẩm";
            model.Value = "/product-manager/config-group-v2/create";
            return model;
          },
        },
      },
      {
        path: "/trade-in-order-old",
        element: <TradeInOrderOld />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Đơn thu cũ";
            model.Value = "/trade-in-order-old";
            return model;
          },
        },
      },
      {
        path: "/trade-in-order-new",
        element: <TradeInOrderNew />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Đơn đổi mới";
            model.Value = "/trade-in-order-new";
            return model;
          },
        },
      },
      {
        path: "/trade-in",
        element: <TradeIn />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Nhóm sản phẩm thu/đổi";
            model.Value = "/trade-in";
            return model;
          },
        },
      },
      {
        path: "/trade-in-product",
        element: <TradeInProductList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm nhóm";
            model.Value = "/trade-in-product";
            return model;
          },
        },
      },
      {
        path: "/trade-in/overview",
        element: <TradeInOverviewV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách đơn đăng ký";
            model.Value = "/trade-in/overview";
            return model;
          },
        },
      },
      {
        path: "/trade-in/category",
        element: <TradeInCategoryV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Ngành hàng & Quy tắc phân loại";
            model.Value = "/trade-in/category";
            return model;
          },
        },
      },
      {
        path: "/trade-in/product",
        element: <TradeInProductV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm thu mua";
            model.Value = "/trade-in/product";
            return model;
          },
        },
      },
      {
        path: "/trade-in/upgrade-product",
        element: <TradeInUpgradeProductV2 />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm lên đời & Trợ giá";
            model.Value = "/trade-in/upgrade-product";
            return model;
          },
        },
      },
      {
        path: "/product-manager/collection",
        element: <Collection />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Bộ sưu tập";
            model.Value = "/product-manager/collection";
            return model;
          },
        },
      },
      {
        path: "/product-manager/collection/product",
        element: <CollectionProdList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm bộ sưu tập";
            model.Value = "/product-manager/collection/product";
            return model;
          },
        },
      },
      {
        path: "/product-manager/collection-frame",
        element: <CollectionFrame />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Quản lý khung sản phẩm";
            model.Value = "/product-manager/collection-frame";
            return model;
          },
        },
      },
      {
        path: "/product-manager/collection-frame/product",
        element: <DetailView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Quản lý sản phẩm trong khung";
            model.Value = "/product-manager/collection-frame/product";
            return model;
          },
        },
      },
      {
        path: "/redirect/url-redirect",
        element: <UrlRedirect />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Url Redirect";
            model.Value = "/redirect/url-redirect";
            return model;
          },
        },
      },
      {
        path: "/installment-order",
        element: <InstallmentOrder />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Installment Order";
            model.Value = "/installment-order";
            return model;
          },
        },
      },
      {
        path: "/installment/installment-setting",
        element: <InstallmentSetting />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Cài đặt trả góp";
            model.Value = "/installment/installment-setting";
            return model;
          },
        },
      },
      {
        path: "/collection/collection-form",
        element: <CollectionForm />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách chờ mua sản phẩm";
            model.Value = "/collection/collection-form";
            return model;
          },
        },
      },
      {
        path: "/collection/collection-recruitment-article",
        element: <ArticleRecruitment />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Bài viết tuyển dụng";
            model.Value = "/collection/collection-recruitment-article";
            return model;
          },
        },
      },
      {
        path: "/email-form",
        element: <ArticleEmail />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách nhận bài viết qua email";
            model.Value = "/email-form";
            return model;
          },
        },
      },

      {
        path: "/behavioral-statistics",
        element: <BehavioralStatistics />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Thống kê hành vi";
            model.Value = "/behavioral-statistics";
            return model;
          },
        },
      },
      {
        path: "/search-keyword",
        element: <SearchKeyword />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Từ khoá tìm kiếm";
            model.Value = "/search-keyword";
            return model;
          },
        },
      },
      {
        path: "/most-view-product",
        element: <MostViewProduct />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm xem nhiều";
            model.Value = "/most-view-product";
            return model;
          },
        },
      },
      {
        path: "/most-add-cart-product",
        element: <MostAddCartProduct />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Sản phẩm thêm vào giỏ nhiều";
            model.Value = "/most-add-cart-product";
            return model;
          },
        },
      },
      {
        path: "/warranteeHacom",
        element: <WarranteeSamsungSessionList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách bảo hành Samsung";
            model.Value = "/warranteeHacom";
            return model;
          },
        },
      },
      {
        path: "/warranty-manager/warranteeHacom",
        element: <WarranteeBrandCategory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách bảo hành";
            model.Value = "/warranty-manager/warranteeHacom";
            return model;
          },
        },
      },
      {
        path: "/warranteeSamsung",
        element: <WarranteeSamsungList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách bảo hành Samsung";
            model.Value = "/warranteeSamsung";
            return model;
          },
        },
      },
      {
        path: "/warranty-manager/brand-list",
        element: <WarranteeBrandCategory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách hãng";
            model.Value = "/warranty-manager/brand-list";
            return model;
          },
        },
      },
      {
        path: "/warranty-manager/brand-category",
        element: <WarranteeBrandCategory />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh mục nhãn hàng";
            model.Value = "/warranty-manager/brand-category";
            return model;
          },
        },
      },
      {
        path: "/Voucher",
        element: <Voucher />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Kích hoạt Voucher";
            model.Value = "/Voucherlist";
            return model;
          },
        },
      },
      {
        path: "/VoucherTest",
        element: <VoucherTest />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách voucher";
            model.Value = "/VoucherTest";
            return model;
          },
        },
      },
      {
        path: "/feedback-manager/customer-input",
        element: <CustommerInput />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách khách hàng nhập tin";
            model.Value = "/feedback-manager/customer-input";
            return model;
          },
        },
      },
      {
        path: "/feedback-manager/customer-review",
        element: <CustommerReviewList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách khách hàng gửi liên hệ";
            model.Value = "/feedback-manager/customer-review";
            return model;
          },
        },
      },
      {
        path: "/feedback-manager/customer-complaint",
        element: <CustomerComplaintList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Thắc mắc, góp ý của khách hàng";
            model.Value = "/feedback-manager/customer-complaint";
            return model;
          },
        },
      },
      {
        path: "/decentralization/menu-group",
        element: <MenuGroupListView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Nhóm menu";
            model.Value = "/decentralization/menu-group";
            return model;
          },
        },
      },
      {
        path: "/decentralization/api-group",
        element: <GroupAPIList />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Nhóm chức năng";
            model.Value = "/decentralization/api-group";
            return model;
          },
        },
      },
      {
        path: "/decentralization/log-web",
        element: <LogWeb />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Log Web";
            model.Value = "/decentralization/log-web";
            return model;
          },
        },
      },
      {
        path: "/collection/collection-recruitment",
        element: <CollectionRecruitment />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Tuyển dụng";
            model.Value = "/collection/collection-recruitment";
            return model;
          },
        },
      },
      {
        path: "/collection/collection-warranty",
        element: <CollectionWarranty />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Yêu cầu bảo hành";
            model.Value = "/collection/collection-warranty";
            return model;
          },
        },
      },
      {
        path: "/upload/upload-image-online",
        element: <UploadImageOnline />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "Upload Image",
              Value: "/upload/upload-image-online",
            };
            return model;
          },
        },
      },
      {
        path: "/clear-cache",
        element: <ClearCache />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: true,
              Group: null,
              Selected: false,
              Text: "Xóa cache",
              Value: "/clear-cache",
            };
            return model;
          },
        },
      },
      {
        path: "/document-manager/congvan-list",
        element: <Congvanlist />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Danh sách công văn";
            model.Value = "/document-manager/congvan-list";
            return model;
          },
        },
      },
      {
        path: "/document-manager/create-congvan-list",
        element: <CongvanCreate />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Tạo mới công văn";
            model.Value = "/document-manager/create-congvan-list";
            return model;
          },
        },
      },
      {
        path: "/document-manager/edit-congvan-list",
        element: <CongVanEdit />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Chỉnh sửa công văn";
            model.Value = "/document-manager/edit-congvan-list";
            return model;
          },
        },
      },
      {
        path: "/document-manager/he-thong-tai-lieu-list",
        element: <HeThongTaiLieu />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: "",
              Value: "",
            };
            model.Text = "Hệ thống tài liệu";
            model.Value = "/document-manager/he-thong-tai-lieu-list";
            return model;
          },
        },
      },
    ],
  },

  {
    path: "auth",
    element: <LayoutAuth />,
    children: [
      {
        path: "login",
        element: <AuthenticationTitle />,
      },
      {
        path: "register",
        element: <AuthenticationRegister />,
      },
      {
        path: "recovery",
        element: <SubmitPassRecovery />,
      },
    ],
  },
]);

export default router;
